 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {
  combineTransactionSteps,
  Extension,
  findChildrenInRange,
  getChangedRanges
} from '@tiptap/core'
import {Fragment, Slice} from '@tiptap/pm/model'
import {Plugin, PluginKey,} from '@tiptap/pm/state'

function getUniqueItems(items, serialize = JSON.stringify) {
  const seen = {}
  return items.filter((item) => {
    const key = serialize(item)
    if (seen[key]) return false
    seen[key] = true
    return true
  })
}








export const UniqueID = Extension.create({
  name: 'uniqueID',
  priority: 10000,
  addOptions: () => ({
    attributeName: 'id',
    types: [],
    generateID: () => crypto.randomUUID(),
    filterTransaction: null
  }),
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [this.options.attributeName]: {
            default: null,
            parseHTML: (element) =>
              element.getAttribute(`data-${this.options.attributeName}`),
            renderHTML: (attributes) =>
              attributes[this.options.attributeName]
                ? {[`data-${this.options.attributeName}`]: attributes[this.options.attributeName]}
                : {}
          }
        }
      }
    ]
  },
  addProseMirrorPlugins() {
    let draggedElement = null
    let shouldTransformPaste = false
    const options = this.options
    return [
      new Plugin({
        key: new PluginKey('uniqueID'),
        appendTransaction: (transactions, oldState, newState) => {
          const docChanged =
            transactions.some((tr) => tr.docChanged) && !oldState.doc.eq(newState.doc)
          const filtered =
            options.filterTransaction && transactions.some((tr) => !options.filterTransaction(tr))
          const ySyncTransaction = transactions.find((tr) => tr.getMeta('y-sync$'))
          if (ySyncTransaction || !docChanged || filtered) return

          const {tr} = newState
          const {types, attributeName, generateID} = options

          const changes = combineTransactionSteps(oldState.doc, transactions )
          const {mapping} = changes

          getChangedRanges(changes).forEach(({newRange}) => {
            const nodes = findChildrenInRange(newState.doc, newRange, (node) =>
              types.includes(node.type.name)
            )
            const existingIDs = nodes
              .map(({node}) => node.attrs[attributeName])
              .filter((id) => id !== null)

            nodes.forEach(({node, pos}, index) => {
              const existingID = _optionalChain([tr, 'access', _ => _.doc, 'access', _2 => _2.nodeAt, 'call', _3 => _3(pos), 'optionalAccess', _4 => _4.attrs, 'access', _5 => _5[attributeName]])
              if (existingID === null) {
                tr.setNodeMarkup(pos, undefined, {...node.attrs, [attributeName]: generateID()})
              }

              const nextNode = nodes[index + 1]
              if (nextNode && node.content.size === 0) {
                tr.setNodeMarkup(nextNode.pos, undefined, {
                  ...nextNode.node.attrs,
                  [attributeName]: existingID
                })
                existingIDs[index + 1] = existingID
                if (!nextNode.node.attrs[attributeName]) {
                  const newID = generateID()
                  tr.setNodeMarkup(pos, undefined, {...node.attrs, [attributeName]: newID})
                  existingIDs[index] = newID
                }
              }

              const uniqueIDs = getUniqueItems(existingIDs)
              const {deleted} = mapping.invert().mapResult(pos)
              if (deleted && uniqueIDs.includes(existingID)) {
                tr.setNodeMarkup(pos, undefined, {...node.attrs, [attributeName]: generateID()})
              }
            })
          })
          return tr.steps.length ? tr : undefined
        },
        view(editorView) {
          const onDragStart = (event) => {
            draggedElement = _optionalChain([editorView, 'access', _6 => _6.dom, 'access', _7 => _7.parentElement, 'optionalAccess', _8 => _8.contains, 'call', _9 => _9(event.target )])
              ? editorView.dom.parentElement
              : null
          }
          window.addEventListener('dragstart', onDragStart)
          return {
            destroy() {
              window.removeEventListener('dragstart', onDragStart)
            }
          }
        },
        props: {
          handleDOMEvents: {
            drop(view, event) {
              if (
                draggedElement === view.dom.parentElement &&
                _optionalChain([event, 'access', _10 => _10.dataTransfer, 'optionalAccess', _11 => _11.effectAllowed]) !== 'copy'
              ) {
                draggedElement = null
                shouldTransformPaste = true
              }
              return false
            },
            paste() {
              shouldTransformPaste = true
              return false
            }
          },
          transformPasted(slice) {
            if (!shouldTransformPaste) return slice
            shouldTransformPaste = false
            const {types, attributeName} = options
            const transformNodes = (fragment) => {
              const children = []
              fragment.forEach((node) => {
                if (node.isText) {
                  children.push(node)
                } else if (types.includes(node.type.name)) {
                  children.push(
                    node.type.create(
                      {...node.attrs, [attributeName]: null},
                      transformNodes(node.content),
                      node.marks
                    )
                  )
                } else {
                  children.push(node.copy(transformNodes(node.content)))
                }
              })
              return Fragment.from(children)
            }
            return new Slice(transformNodes(slice.content), slice.openStart, slice.openEnd)
          }
        }
      })
    ]
  }
})
